import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParentsRoominline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 32.5,
			cy: 14.5,
			r: 5.5
		}), /* @__PURE__ */ _jsx("path", { d: "M38.493 31.268L39 37H26c.117-2.12.213-3.969.288-5.549l-6.403 4.8c-1.316.986-3.216.763-4.244-.5-1.028-1.262-.795-3.085.521-4.072l10.732-8.045c.187-.14.385-.255.592-.347.33-.191.742-.287 1.236-.287h7.033c.088 0 .172.003.254.009a3.102 3.102 0 0 1 2.097.606l10.732 8.045c1.316.987 1.549 2.81.521 4.072s-2.928 1.486-4.244.5l-6.622-4.964zm-18.45 13.959l-.006-.006L25.636 40l4.49 4.815-3.243 3.024 3.41 3.656a3.239 3.239 0 1 1-4.738 4.418l-5.685-6.096a3.239 3.239 0 0 1 .173-4.59zm25.077 0l.006-.006L39.527 40l-4.49 4.815 3.243 3.024-3.41 3.656a3.239 3.239 0 1 0 4.738 4.418l5.685-6.096a3.239 3.239 0 0 0-.173-4.59z" })]
	})
});
export default SvgParentsRoominline;
